// Add third-party dependencies.
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved
import * as FullStory from "@fullstory/browser"

import App from "./App";
import theme from "./styles/theme";
// eslint-disable-next-line import/no-unresolved
import "pepsico-ds/css";

import { FULLSTORY_ORGID } from "config/config";
import { ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as PepsicoThemeProvider }  from "pepsico-ds";

// Initialize FullStory
if (FULLSTORY_ORGID) {
  FullStory.init(
    { orgId: FULLSTORY_ORGID },
    ({ sessionUrl }) =>
      console.log(`Started session: ${sessionUrl}`),
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <PepsicoThemeProvider>
          <App />
        </PepsicoThemeProvider>
      </ThemeProvider>  
    </BrowserRouter>
  </React.StrictMode>,
);
